function applyNativeSwatches(root) {
  root.querySelectorAll('.swatch__input').forEach(function(input) {
    var label = input.nextElementSibling;
    if (!label) label = root.querySelector('label[for="' + input.id + '"]');
    if (!label) return;

    var swatchImage = input.dataset.swatchImage;
    var swatchColor = input.dataset.swatchColor;

    if (swatchImage && swatchImage !== '' && swatchImage !== 'null') {
      label.style.backgroundImage = 'url(' + swatchImage + ')';
      label.style.backgroundSize = 'cover';
      label.style.backgroundPosition = 'center';
    } else if (swatchColor && swatchColor !== '' && swatchColor !== 'null') {
      label.style.backgroundColor = swatchColor;
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  applyNativeSwatches(document);
});

document.addEventListener('quickview:open', function(e) {
  if (e.detail && e.detail.container) applyNativeSwatches(e.detail.container);
});
